<div class="header d-flex align-items-center" style="background-color: #f5f5f5; padding: 15px; border-radius: 5px;">
    <!-- Logo on the left -->
     <!-- https://cdn.builder.io/api/v1/image/assets/TEMP/9498edba-5ab7-4231-9132-36334e2e7c6d? -->
    <img [src]="logoUrl" alt="Logo"
        style="height: 30px; width: auto;">

    <!-- Center Text -->
    <h1 class="text-center flex-grow-1" style="margin: 0; font-size: 1.5rem; color: #024e67;margin-left: -8rem;">
        Terms & Conditions
    </h1>
</div>
<div class="container pt-2" style="text-align: justify;" [innerHTML]="termsHtml"></div>
<!-- <div class="container pt-2" style="text-align: justify;">
    <p><strong>TERMS AND CONDITIONS FOR USE OF {{appName}} (“PLATFORM”) FOR MERCHANTS ,BRANDS AND
            COMPANIES</strong></p>
    <p>WELCOME TO {{appName}}. THE FOLLOWING ARE THE TERMS AND CONDITIONS OF YOUR ACCESS TO AND USAGE OF
        {{appName}} ECOSYSTEM, WHICH HENCE FORTH WILL BE REFERRED TO AS THE “AGREEMENT”. MERCHANT OR BRAND OR
        COMPANY (“YOU” OR “YOUR”) ACKNOWLEDGE THAT YOU HAVE READ, REVIEWED, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE
        TERMS, AND TO COMPLY WITH ALL APPLICABLE LAWS AND REGULATIONS. BY CLICKING THE ‘AGREE’ BUTTON AT THE END OF THIS
        DOCUMENT YOU INDICATE YOUR ACCEPTANCE OF THESE TERMS AND CONDITIONS AND WILL HENCEFORTH BE IN A LEGALLY BINDING
        AGREEMENT BETWEEN YOU AND MAPMYID INC.,(which also trades as Ship2MyID, and <strong>HEREINAFTER REFERRED AS
            Ship2MyID</strong>),
        A DELAWARE USA CORPORATION HAVING ITS OFFICE AT 430 BRIGHTMORE DOWNS, ALPHARETTA, GA, 30005.</p>
    <div class="section-title">1. DEFINITIONS AND INTERPRETATION</div>
    <p>These Definitions and interpretations are intended to help clarify terms and concepts used in this Agreement and
        ensure that the Merchant fully understands its obligations and rights when using the {{smallappName}}.</p>
    <p><strong>Advertiser:</strong> Any Merchant, Brand, or Company that creates and runs campaigns or deals on the
        {{smallappName}}.
    </p>
    <p><strong>Campaign:</strong> A marketing initiative by a Merchant to promote products or services through the
        {{smallappName}},
        typically running for a specified period.</p>
    <p><strong>Consumer:</strong> An individual who uses the {{smallappName}} to browse, select, and redeem deals and
        offers provided
        by Merchants.</p>
    <p><strong>Consumer Data Protection & Privacy Policy:</strong> The policy governing how Ship2MyID and associated
        Merchant’s handle
        and protect consumers’ personal data, drafted in line with the local government’s regulation pertaining to data
        privacy and protection. It outlines the measures taken to ensure data privacy and compliance with relevant data
        privacy and protection laws in {{countryName}}</p>
    <p><strong>Coupon:</strong> A digital voucher provided by Merchants through the {{smallappName}} that Consumers
        can use to claim
        discounts or special offers.</p>
    <p><strong>Coupon Procurement: </strong>The act of a Consumer downloading or getting a digital coupon code or
        discount link from the
        {{smallappName}} to further use it for claiming an offer or obtaining a discount from the merchant.</p>
    <p><strong>Coupon Redemption:</strong> The act of a Consumer using a digital coupon provided by a Merchant through
        the PosoKlick
        Deals App to claim an offer or discount.</p>
    <p><strong>Fulfilment:</strong> The process by which a Merchant honours and completes a consumer's redemption of a
        coupon or deal as
        per the terms of the campaign.</p>
    <p><strong>Indemnify: </strong>A legal obligation on one party to compensate for the harm, loss, or damage caused to
        another party.
    </p>
    <p><strong>Non-Personally Identifiable Information (Non-PII):</strong> Information that cannot be used to identify a
        specific
        individual, such as aggregated data about Consumers' interaction with the {{smallappName}}, or individual’s
        unique digital ID.</p>
    <p><strong>Merchant’:</strong> Brand, Company, Shops, Merchants, Businesses, Advertisers or any individual or entity
        that places a
        deal on the Platform.</p>
    <p><strong>Offer Period: </strong>The duration during which a campaign or deal is active and available for Consumers
        to redeem.</p>
    <p><strong>Personally Identifiable Information (PII):</strong> Any data that could potentially identify a specific
        individual, such
        as name, address, email, phone number, etc.</p>
    <p><strong>Platform:</strong> Refers to the {{smallappName}} and all its associated digital interfaces and
        services.</p>
    <p><strong>Parties:</strong> shall mean Ship2MyID, Post Office, Service Provider or Merchants, whom altogether may
        be referred as
        Parties.</p>
    <p><strong>Service Provider: </strong>Ship2MyID in partnership with the respective country’s Post Office,
        responsible for managing
        and operating the {{smallappName}}.</p>
    <p><strong>{{smallappName}}:</strong> The digital multi-patented platform developed and owned by Ship2MyID and
        used by the
        country’s Post Office as a white label service, for offering and managing deals and campaigns from Merchants and
        Brand Company.</p>
    <p><strong>Solicitation: </strong>The act of requesting or attempting to obtain something from someone. In this
        context, it refers to
        Merchants seeking to obtain PII from Consumers.</p>
    <p><strong></strong>Suspension: The potentially temporary deactivation of a Merchant’s account or campaign on the
        {{smallappName}}
        due to non-compliance with terms and conditions.</p>
    <p><strong>Termination:</strong> The permanent deactivation or removal of a Merchant’s account or campaign from the
        PosoKlick Deals
        App due to violations of terms and conditions.</p>
    <p><strong>Transaction Declaration:</strong> The requirement for Merchants to report all coupon redemptions and
        transactions
        facilitated through the {{smallappName}} to Ship2MyID for tracking and compliance purposes.</p>
    <p><strong>Governing Law: </strong>The legal framework under which the terms and conditions are interpreted and
        enforced. This is
        based on the laws of the country where the service is provided.</p>
    <p><strong>Compliance:</strong> Adherence to laws, regulations, and policies relevant to the use of the PosoKlick
        Deals App by
        Merchants.</p>
    <p><strong>Notification of Changes:</strong> The process by which Ship2MyID informs Merchants of amendments to the
        terms and
        conditions via email or platform notifications.</p><br>
    <div class="section-title">2. INTRODUCTION</div>
    <p>The terms & conditions of this Agreement govern the relationship between three primary entities within the
        {{smallappName}} ecosystem:</p>
    <ul>
        <ol>
            <li>Merchants or Brand Company</li>
            <li>Consumers</li>
            <li>{{smallappName}} (partnership between Ship2MyID and {{countryName}} Post)</li>
        </ol>
    </ul>

    <div class="section-title">3. OBLIGATIONS OF MERCHANTS: CONSUMER DATA PRIVACY AND PROTECTION</div>
    <ul>
        <ol type="i">
            <li>
                <p>Merchants must always conform to and comply with the consumer data privacy and protection policy of
                    Ship2MyID
                    and
                    the respective country’s post office.</p>
            </li>
            <li>
                <p><strong>Non-Solicitation of PII:</strong> Merchants or Brand Company <strong>shall abstain</strong>
                    from
                    directly
                    or indirectly soliciting any
                    <strong>Personally Identifiable Information (PII)</strong> from Consumers within the PosoKlick Deals
                    App
                    system.
                    Violation of
                    this policy may result in penalties and/or applicable legal action by competent government
                    authorities
                    and
                    the
                    merchant shall solely be responsible for the same and shall indemnify Ship2MyID in the event of any
                    claims
                    by
                    the Consumers or government authorities against Ship2MyID.
                </p>
            </li>
            <li>
                <p>Ship2MyID does not guarantee the security of the services or transaction data, and Ship2MyID will not
                    be
                    responsible in the event of any infiltration of its security systems, provided that Ship2MyID has
                    used
                    commercially reasonable efforts to prevent any such infiltration. Merchant will only have their
                    unique
                    digital
                    ID and will not make any attempt to connect with those Consumers, without their explicit permission.
                    Ship2MyID
                    will take the best efforts to validate the Consumer’s demographic data but cannot vouch for some of
                    the
                    demographic information that is incorrectly given by consumers. We use multiple validation process
                    to
                    check
                    authenticity of mobile phone numbers and email IDs.</p>
            </li>
            <li>
                <p>The Merchant acknowledges and agrees that the protection and security of Consumer data, shipping data
                    shall
                    be
                    solely responsibility of the Merchant.</p>
            </li>
            <li>
                <p>Standard of Care. Except as otherwise permitted in writing by Ship2MyID, the Merchant will (a) use
                    the
                    same
                    degree of care that it uses to protect the confidentiality of its own Confidential Information of
                    like
                    kind
                    (but
                    in no event less than reasonable care), (b) not disclose or use any Confidential Information of
                    Ship2MyID
                    for
                    any purpose outside the scope of this Agreement, and (c) limit access to Confidential Information of
                    Ship2MyID
                    Consumers to those of its employees, contractors, advisors, and agents with a need to know or who
                    need
                    access
                    for purposes consistent with this Agreement and who are bound by confidentiality obligations at
                    least as
                    stringent as those in this Agreement.</p>
            </li>
            <li>
                <p>Consumer Data Protection: Merchants shall not ask Consumers for any personal data or make any
                    adjustments
                    outside
                    the terms and conditions specified in this Agreement. Any violation of this clause may result in
                    penalties,
                    suspension, or termination of the Merchant's account.</p>
            </li>
        </ol>
    </ul>
    <strong>
        <p>A.Honouring and Redemption of Coupons & Sharing of Transaction Details</p>
    </strong>
    <p>Merchants must adhere to the following requirements for deals and campaigns conducted on the {{smallappName}}
        platform:</p>
    <ul>
        <li>
            <p> a. <strong>Best Discount Guarantee:</strong> Merchants are required to provide the most favourable deals
                on
                the
                PosoKlick Deals
                App
                platform. Consumers must not find a better deal from the same Merchant posted in any other marketplace
                or
                platform.</p>
        </li>
        <li>
            <p> b. <strong>Honouring Coupons:</strong> Merchants are expected to honour all redemption coupons and
                complete
                all
                fulfilment as per
                the
                campaign or deal offered, provided;</p>
        </li>
        <ul>
            <li>
                <p> i. the claim is within the offer period</p>
            </li>
            <li>
                <p> ii. you as a merchant, accept only redemption codes displayed directly in the Poso Klick App. Codes
                    presented
                    through
                    screenshots, verbal communication, or other methods should not be considered valid and thus, should
                    not
                    be
                    honoured</p>
            </li>
        </ul>
    </ul>
    <strong>
        <p>B.Merchant Media & Social Sharing Consent</p>
    </strong>
    <p>By registering on the PosoKlick platform, you expressly authorize {{countryName}} Post and Ship2MyID to disseminate
        images, videos, and promotional content that pertain to your business's engagement with the application. This
        includes the potential for such content to be featured across {{countryName}} Post's and Ship2MyID's official social
        media channels (including but not limited to Facebook and Instagram). Your business's social media pages may
        also be tagged in these posts to promote visibility.</p>
    <p>This authorization aims to enhance your business's exposure and increase engagement with consumers. Should you
        choose to withdraw this consent at any time, please submit your request in writing.</p>
    <strong>
        <p>C.Merchant’s Obligation to Declare Coupon Redemption Data</p>
    </strong>
    <p>Merchants must declare each coupon redemption or transaction with the consumers, that is routed through the
        {{smallappName}}. Any non-compliance or attempts to conceal this information from sharing with Ship2MyID will
        lead to penalties and/or temporary suspension of the campaign or merchant account from the system.</p>
    <div class="section-title">4. ADVERTISER RESPONSIBILITIES AND RESTRICTIONS</div>
    <strong>
        <p>A. Compliance with Laws and Regulations</p>
    </strong>
    <ul>
        <ol>
            <li>
                <p>Merchants must ensure that their advertisements comply with all applicable laws, regulations, and
                    guidelines,
                    including those set forth by regulatory authorities in that country.</p>
            </li>
            <li>
                <p>Advertisers must not engage in deceptive, misleading, or unlawful advertising practices.</p>
            </li>
        </ol>
    </ul>
    <strong>
        <p>B. Prohibited Content</p>
    </strong>
    <ul>
        <li>
            <p>Advertisers may not promote products, services, or content that is illegal, unsafe, or otherwise violate
                our
                community standards. This includes but is not limited to:</p>
            <ol>
                <li>
                    <p>Illegal products or services</p>
                </li>
                <li>
                    <p>Discriminatory practices</p>
                </li>
                <li>
                    <p>Infringement of intellectual property rights</p>
                </li>
                <li>
                    <p>Content that is offensive, inappropriate, or harmful (nudity, pornography, drugs etc.)</p>
                </li>
            </ol>
        </li>
    </ul>
    <strong>
        <p>D. Payment and Billing Conditions</p>
    </strong>
    <ul>
        <li>
            <p>Due to limitations in Ship2MyID’s payment system with Stripe, which allows only one week of
                preauthorisation,
                Ship2MyID will trust the Merchant and charge the account under the following specific conditions:</p>
        </li>
        <ol>
            <li>
                <p>When the engagement structure results in an invoice of $15.</p>
            </li>
            <li>
                <p>When the deal expires.</p>
            </li>
            <li>
                <p>When the deal meets its budget criteria.</p>
            </li>
        </ol>
        <li>
            <p>If payment is not received, the Merchant owes Ship2MyID the outstanding amount and may be sent for
                collections. Ship2MyID reserves the right to temporarily or permanently remove the Merchant from the
                platform if
                payment is not made within one month of the due date.</p>
        </li>
        <li>
            <p>Ship2MyID reserves the right to suspend or terminate the Merchant’s account for non-payment or
                repeated
                billing disputes.</p><br>
        </li>
    </ul>
    <div class="section-title">5. COMPLIANCE AND PENALTIES</div>
    <ul>
        <li>
            <p>Merchants must adhere to all applicable laws and regulations, including those related to Consumer
                protection,
                data privacy, and marketing practices.</p>
        </li>
        <li>
            <p>Failure to comply with these terms may result in the suspension or termination of the Merchant’s account,
                removal
                of offers, and legal actions and penalties where applicable.</p>
        </li>
        <li>
            <p>Any penalty levied on {{smallappName}}, arising due to default or non-compliance of local governing
                law
                from
                the Merchant, shall be borne by the respective Merchant.</p>
        </li>
        <li>
            <p><strong>Best Price Matching:</strong> Merchants must match the best price offered to Consumers if a
                coupon is
                not
                redeemed,
                provided the terms and conditions of the deal are accurate. Failure to honour this requirement may
                result in
                removal of the Merchant’s listing from the {{smallappName}}.</p>
        </li>
        <li>
            <p><strong>Coupon Redemption Compliance:</strong> If a coupon is not honoured as per the agreed terms,
                Ship2MyID
                reserves the right
                to remove the Merchant from the platform and take further legal or corrective action as deemed
                necessary.
            </p>
        </li>
    </ul>
    <div class="section-title">6. LIABILITY AND INDEMNIFICATION</div>
    <ul>
        <li><p>Ship2MyID and/or Post Office will not be liable for any indirect, incidental, special, or consequential
            damages
            arising from the use of the platform. IN NO EVENT WILL SHIP2MYID’S LIABILITY ARISING OUT OF THIS AGREEMENT
            SHALL
            EXCEED $100 (US DOLLAR ONE HUNDRED ONLY)</p></li>
       <li> <p>Merchants agree to indemnify and hold harmless Ship2MyID and Post Office against any claims, damages, losses,
            liabilities, and expenses arising out of or in connection with their use of the platform. Further Merchant
            will
            indemnify, defend and hold harmless Ship2MyID and Post Office, its officers, directors, agents and
            employees,
            from and against any and all claims, losses, demands, liabilities, damages, costs and expenses (including
            reasonable attorneys’ fees), either arising out of or relating to (I) the breach of any representation or
            warranty by Merchant, (ii) the sale or use of any product or services sold by Merchant, (iii) claims brought
            or
            damages suffered by any Consumers or (iv) the breach of this Agreement or any representation or warranty by
            Merchant.</p></li>
       <li> <p>Any penalty levied on {{smallappName}}, arising due to default or non-compliance of local governing law
            from
            the Merchant, shall be borne by the respective Merchant.</p></li>
    </ul>
    <div class="section-title">7. WARRANTIES AND DISCLAIMERS</div>
    <p>EXCEPT AS EXPRESSLY SET FORTH ABOVE AND TO THE EXTENT PERMITTED BY APPLICABLE LOCAL GOVERNING LAW, SHIP2MYID
        MAKES NO WARRANTY OF ANY KIND, EXPRESS, IMPLIED OR STATUTORY, REGARDING THE SERVICES OR SOFTWARE, PLATFORM, AND
        ALL SUCH WARRANTIES, INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
        PARTICULAR PURPOSE HEREBY EXPRESSLY DISCLAIMED BY SHIP2MYID. MERCHANT ACKNOWLEDGES THAT SHIP2MYID HAS NOT
        REPRESENTED OR WARRANTED THAT THE SERVICES WILL BE UNINTERRUPTED, ERROR FREE OR WITHOUT DELAY OR WITHOUT
        COMPROMISE OF THE SECURITY SYSTEMS RELATED TO THE SERVICES.</p>
    <div class="section-title">8. INTELLECTUAL PROPERTY RIGHTS</div>
    <p>All rights not expressly granted to Merchant under this Agreement are reserved by Ship2MyID and its licensors.
        This Agreement does not give you an interest in or to Ship2MyID’s intellectual property rights, POSOKLICK DEALS
        APP OR Platform or software. Nothing in this Agreement constitutes a waiver of Ship2MyID’s intellectual property
        rights under any law. Merchant shall not copy, imitate, or use above mentioned intellectual property rights
        without Ship2MyID’s prior written consent. In addition, all page headers, custom graphics, button icons, and
        scripts are service marks, trademarks, and/or trade address of Ship2MyID and Merchant shall not copy, imitate,
        or use them without our prior written consent. All rights, title and interests in and to the Ship2MyID website,
        any content thereon, the Services, the technology related to the Services, and any and all technology and any
        content created or derived from any of the foregoing, is the exclusive property of Ship2MyID and its licensors.
    </p>
    <p><span class="section-title">9. NO ASSIGNMENT.</span> Merchant may not assign this Agreement without the prior written consent of Ship2MyID.</p>
    <p><span class="section-title">10. GOVERNING LAW.</span> These terms and conditions shall be governed by and construed in accordance with the laws of
        the respective country in which the services are provided.</p>
    <p><span class="section-title">11. TERMINATION. </span>Ship2MyID reserves the right to terminate or suspend a Merchant's account at any time for
        violations of the terms and conditions of this Agreement or for any behaviour deemed detrimental to the
        platform's integrity and users.</p>
    <div class="section-title">12. CONTACT INFORMATION</div>
    <p>For any questions or concerns regarding these terms, please contact our support team at</p>
    <p><span class="section-title">13. CHANGES TO PLATFORM FUNCTIONALITY.</span> Ship2MyID may modify the services from time to time in Ship2MyID’s
        reasonable discretion and upon reasonable electronic or written notice to Merchant, provided that such
        modifications shall not materially diminish the functionality of the Platform.</p>
    <p><span class="section-title">14. RELATIONSHIP.</span> Nothing in this Agreement will be deemed or is intended to be deemed, nor will it cause, any of
        the Parties to be treated as partners, joint ventures, or otherwise as joint associates for profit. Merchant do
        not have any authority of any kind to bind Ship2MyID.</p>
    <p><span class="section-title">15. SEVERABILITY.</span> In the event that any provision of this Agreement is unenforceable or invalid such
        unenforceability or invalidity will not render this Agreement unenforceable or invalid as a whole, and in such
        event, such provision will be changed and interpreted so as to best accomplish the objectives of such
        unenforceable or invalid provision within the limits of applicable law or applicable court decisions.</p>
    <p><span class="section-title">16. FORCE MAJEURE (EVENTS BEYOND THE PARTIES’ CONTROL).</span> Neither party shall be liable for any failure or delay in
        performing any obligation under this Agreement that is due to the causes beyond its reasonable control.</p>
    <p><span class="section-title">17. ENTIRE AGREEMENT AND MODIFICATION. </span>Unless otherwise required by law and unless otherwise agreed between the
        parties, Ship2MyID may change the terms and conditions of the Agreement from time to time, and such change will
        become effective upon the date on which it is posted on the Ship2MyID websites. Ship2MyID will do its best to
        keep all stakeholders notified. The Merchant is responsible for checking the website regularly for such changes.
        By continuing to access or use the Services, the Merchant agrees to be bound by the revised Agreement.</p><br>
    <p><strong>BY AGREEING TO THESE TERMS AND CONDITIONS, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO
            BE BOUND
            BY ALL THE TERMS AND CONDITIONS STATED ABOVE. FURTHER, THE MERCHANT AGREES THAT BY USING THE PLATFORM AND
            CLICKING THE “AGREE” BUTTON IT SHALL CONSTITUTE A VALID ELECTRONIC SIGNATURE AND ALSO AGREES THAT ELECTRONIC
            CONSENT HAS AND WILL HAVE THE SAME LEGAL EFFECT AS A PHYSICAL SIGNATURE.</strong></p><br>

</div> -->